import PropTypes from 'prop-types';
import React from 'react';
import CTA from '../CTA/CTA';
import FeatureLayoutStyles from './FeatureLayout.styled';
import { extractColors, formatHttpsUrl } from '@utils/utils';

const getFeatureCard = (cta) => {
  return {
    image:
      cta.ctaImage !== null ? formatHttpsUrl(cta?.ctaImage?.file?.url) : null,
    imageAlign: 'Center', // cta.ctaImageLocation,
    contentAlign: 'Left Align', // cta.alignCtaContent
    customCategory: cta.ctaCustomCategory,
    tag: cta.ctaTag,
    headingText: cta.ctaHeader,
    backgroundColor: extractColors(cta.ctaBackgroundColor), // "Kiddie Pool: #00B0AC"
    buttonLocation: 'Linked Card-No Button', // cta.ctaButtonLocation
    buttonUrl: cta.firstCtaButtonUrl,
  };
};

// This handles the layout for the Home Page featured stories.  There are always 3.
const FeatureLayout = ({ posts }) => {
  const featureCard0 = posts && posts[0] ? getFeatureCard(posts[0]) : {};
  const featureCard1 = posts && posts[1] ? getFeatureCard(posts[1]) : {};
  const featureCard2 = posts && posts[2] ? getFeatureCard(posts[2]) : {};

  return (
    <FeatureLayoutStyles>
      {posts ? (
        <div className="cta-container">
          {featureCard0 && featureCard1 && featureCard2 ? (
            <div className="cta-grid-container">
              <div className="cta-three-container">
                <div className="cta-div left">
                  <CTA key="key=2-0" {...featureCard0} />
                </div>
                <div className="cta-div right-a">
                  <CTA key="key=3-0" {...featureCard1} />
                </div>
                <div className="cta-div right-b">
                  <CTA key="key=3-1" {...featureCard2} />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
    </FeatureLayoutStyles>
  );
};

FeatureLayout.propTypes = {
  posts: PropTypes.any,
};

export default FeatureLayout;
